export const ATT = 'att';

export const JASPER = 'jasper';

export const JASPER_STATUS = {
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED',
};
